import utils from './utils';

const URL = `${BASE_API_URL}/quests`;

export default {
    getQuestions: (questId) => utils.get(`${URL}/${questId}.json`),
    submitQuestions: (questId, answers) => utils.handlePut(`${URL}/${questId}.json`, { answers }),
};



// WEBPACK FOOTER //
// ./src/api/quests.js